;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:qogita-web-sellers":true});}catch(e){}}();import clsx from 'clsx'
import type { PropsWithChildren } from 'react'

export function PageGrid({
  className,
  ...props
}: PropsWithChildren<{
  className?: string
}>) {
  return (
    <div
      {...props}
      className={clsx(
        className,
        'grid grid-cols-4 gap-4 sm:grid-cols-6 md:grid-cols-6 lg:grid-cols-10 xl:gap-6',
      )}
    />
  )
}

export function PageGrid4Or10({
  className,
  ...props
}: PropsWithChildren<{
  className?: string
}>) {
  return (
    <div
      {...props}
      className={clsx(
        className,
        'grid grid-cols-8 gap-4 lg:grid-cols-10 xl:gap-6',
      )}
    />
  )
}
